<template>
    <div id="container">
      <el-container>
        <el-aside id="elAside">
          <submenu></submenu>
        </el-aside>
        <el-container>
        <el-main class="right">
          <router-view></router-view>
        </el-main>
        </el-container>
      </el-container>  
    </div>
</template>

<script>
import CourseTitle from '@/components/courses/myCourses/courseTitle'
import submenu from '@/components/submenu/submenu'

export default {
  components: {
    CourseTitle,
    submenu  
  }
}
</script>

<style>
  #container{
    min-height: 100%;
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 100px;
  }

  .right{
    border-left: 1px solid rgba(171, 174, 179, 0.3);
    padding-top: 0px;
  }

  #elAside {
    width:230px !important;
  }

  @media (max-width:1024px){
    #elAside {
      width: 195px !important;
    }
  }

  @media (max-width:767px){
    #elAside {
      display: none;
    }

    #container{
      min-height: 100%;
      max-width: 1200px;
      margin: 0 auto;
      margin-top: 20px;
    }

    .right{
      border-left: 0px;
      padding: 20px 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/index.vue